import { LoadableAfterPaint } from '@confluence/loadable';

export const ResolvedInlineCommentsCounterLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ResolvedInlineCommentsCounter" */ '../src/ResolvedInlineCommentsCounter'
			)
		).ResolvedInlineCommentsCounter,
});
